module.exports = __webpack_public_path__ + "img/4.d25c7274.jpg";